import Controller from "./customer.controller";
import template from "./customer.html";

const customer = {
  template,
  controller: Controller,
};

export default customer;



// WEBPACK FOOTER //
// ./src/pages/customer/customer.component.js